

var mainVarinat = '', mainPrice = '', totalProd = 0;
var $html = '', mainhandle = '';
var $Produurl = '', $prodHandle='';
var pusharray = [];
var mainTag='';
var mainArrayAllProducts ={};
var totalsAllProducts = 0;
var repairsUniverse = {


  init: function () {

    this.navigationMain();
    this.closePopup(); //for all popup close
    this.meanMenu(); // meanmenu
    //this.bxSider(); //bxslide
    this.dropdown(); //
    this.slickCall();
    this.heapBox();
    this.toolTip();
    this.footerToggle();
    this.readmore();
    this.addtocartPopup();
    this.collectionAfterAdd(); //after add to cart in collection page
    if($('body').hasClass('template-index')){
      this.getFromURLCustomBanner();
      if($(window).width() > 767){
      	$('#custom-banner-mobile').remove();
        this.customNewBanner();
      }else{
        $('#horizontalTab').remove();
        this.customMobileBanner();
      }
      this.goback();
    }
    if($('body').hasClass('template-collection')){
      this.collectionPreLoad();
      this.customLoadForAllTabs();
      this.customViewMore();
    }
    this.getUrlVars();
    this.grid();
    this.qty();
    this.collectionFilter(); //collection sidebar
    this.faqPage(); // FAQ
    this.removeItemsFromCart(); //remove item from cart
    this.qtyUpdateCart();
    this.gridjs();
    this.repairGuides(); // repairguide page
    if($('#shopify-section-collection-template').length > 0){
       this.loadMore(); // load more products in collection page
       this.viewMoredetail();
    }
    if($('.blog-wrap .sidebar').length > 0){
      this.blogpage();
    }
    if($('.template-cart').length > 0){
      this.cartPage();
    }

	this.productdisclaimer();
	this.allImageScript();
  },
  allImageScript: function(){
	var countTime = 0;
    var storeTimeInterval = setInterval(function(){
      countTime++;
      $('img').removeAttr('width');
      $('img').removeAttr('height');
      if(countTime == 12){
        clearInterval(storeTimeInterval);
      }
    },500);
    $('ul.payment li').each(function(index,e){
      var $this = $(this);
      if($('img',this).attr('alt') == 'venmo'){
        $this.hide();
      }
      if($('img',this).attr('alt') == 'apple_pay'){
        $this.hide();
      }


    });

  },
  productdisclaimer: function(){
    $('#disclaimer').on('click',function(e){
      $('#disclaimer-popup').fadeIn();
      $('body').addClass('productPopupActive');
      $('body').addClass('Dis-productPopupActive');
    });

    $('#disclaimer .close').on('click',function(e){
      $('#disclaimer-popup').fadeOut();
      $('body').removeClass('productPopupActive');
      $('body').removeClass('Dis-productPopupActive');
    });
  },
  customViewMore: function(){
    $('body').on('click','a#viewMore_sub', function(e){
      var $id = $(this).attr('data-this');
      var $newUrl = $(this).attr('data-href');



      $('#'+$id+' #loading').show();
      $('#'+$id+' #viewMore_sub').hide();
      $.ajax({
        type: "GET",
        url: $newUrl,
        success: function (data) {


          $('#'+$id+' #loading').hide();
          var $data = $(data).find('#all .single-device-tab').html();
          $('#'+$id+' .single-device-tab').append($data);
          if($(data).find('.next').length > 0){
            var pagination = $(data).find('#viewMore').attr('data-href');
            $('#'+$id+' a#viewMore_sub').attr('data-href', pagination);
            $('#'+$id+' #viewMore_sub').show();
          }else{
            $('#'+$id+' #viewMore_sub').hide();
          }
          $('.single-device-tab .device-content .productName').responsiveEqualHeightGrid();

        }
      });
    });
  },
  customLoadForAllTabs: function(){
    setTimeout(function(){
      $('#horizontalTab-collection li [data-checkHref="all"]').trigger('click');

      var rType = repairsUniverse.getUrlVars()["RepairType"];

      if(rType){
        $('#horizontalTab-collection li [data-checkHref="'+rType+'"]').trigger('click');

      }
    },2000);


    $('body').on('click','#horizontalTab-collection li [data-checkHref], #horizontalTab-collection .r-tabs-accordion-title [data-checkHref]', function(e){
      $('.single-device-tab .device-content .productName').responsiveEqualHeightGrid();
      if($(this).attr('data-checkHref')){
        var $id= $(this).attr('href');


        console.log($(this).attr('data-checkHref'));

       if($('[data-collection-handle]').length > 0 && $.trim($('[data-collection-handle]').text()) != ''){


          if($(this).attr('data-checkHref') == "all"){
            //var $newUrl = window.location.href+'?view=custom';
            var $url = window.location.href.split('?constraint=');
            var $newUrl = $url[0].replace('accessories',$url[1]) +'?constraint=accessories&view=custom';

          }else{
            var $newUrl = window.location.href+'+'+$(this).attr('data-checkHref')+'&view=custom';
          }
        }else{

          if($(this).attr('data-checkHref') == "all"){
            var $newUrl = window.location.href+'?view=custom';
          }else{
            var $newUrl = window.location.href+'?constraint='+$(this).attr('data-checkHref')+'&view=custom';
          }
        }

        console.log($newUrl);

        if($(this).attr('data-checkHref') != "all"){
          $($id+' .single-device-tab').html('<img alt="Loading Image" style="" class="loading_image" id="loading" src="//cdn.shopify.com/s/files/1/2305/6727/files/repairs__loader.gif?6462">');
                                             $($id+' .single-device-tab').addClass('loader-open');
        }

        $($id+' .viewmore').hide();
        $($id+' .single-device-tab').html('<img alt="Loading Image" style="" class="loading_image" id="loading" src="//cdn.shopify.com/s/files/1/2305/6727/files/repairs__loader.gif?6462">');
                        $($id+' .single-device-tab').addClass('loader-open');


        $.ajax({
          type: "GET",
          url: $newUrl,
          success: function (data) {

            var $data = $(data).find('#all .single-device-tab').html();
            if($.trim($data) != ''){
              $($id+' .single-device-tab').removeClass('loader-open');
              $($id+' .single-device-tab').html($data);
            }else{
              $($id+' .single-device-tab').removeClass('loader-open');
              if($.trim($(data).find('.checkDescription')).length > 0){
                $($id+' .single-device-tab').html('<h4 class="itemNotAvailable itemNotAvailable-withText">Items not available.</h4>');
              }else{
                $($id+' .single-device-tab').html('<h4 class="itemNotAvailable">Items not available.</h4>');
              }

            }

            if($(data).find('.next').length > 0){
              var pagination = $(data).find('a#viewMore').attr('data-checkHref');
              $($id+' a#viewMore_sub').attr('data-checkHref', pagination);
              $($id+' .viewmore').show();
            }else{
              $($id+' .viewmore').hide();
            }
          $('.collection-desc').show();

          	$('.single-device-tab .device-content .productName').responsiveEqualHeightGrid();

          }
        });

      }
    });

  },
  cartPage:function(){
    if($(window).width() > 767){
      var summaries = $('.order-summery-wrap');
      summaries.each(function(i) {
        var summary = $(summaries[i]);
        var next = summaries[i + 1];

        summary.scrollToFixed({
          marginTop: $('.header-section').outerHeight(true) + 15,
          limit: function() {
            var limit = 0;
            if (next) {
              limit = $(next).offset().top - $(this).outerHeight(true) - 10;
            } else {
              limit = $('.footer-down').offset().top - $(this).outerHeight(true) - 60;
            }
            return limit;
          },
          zIndex: 999
        });
      });
    }else{
      var mainheight = $('#order-summery-wrap-n').outerHeight();
      var mainoffsettop = $('#order-summery-wrap-n').offset().top;
      var mainOffsetBottom = mainheight+mainoffsettop;
      $('#order-summery-wrap-n').scrollToFixed({
        bottom: -154,
        limit: $('#order-summery-wrap-n').offset().top
      });
      $(window).scroll(function() {
        var winScroll =$(window).scrollTop();
        if(winScroll > mainOffsetBottom){
          $('#cart_subtotal_sticky_mobile').addClass('active');
        }else{
          $('#cart_subtotal_sticky_mobile').removeClass('active');
        }
      });
    }
  },

  collectionPreLoad: function(){
    $(document).ready(function($) {
      var Body = $('.collection-horizontal');
      Body.addClass('preloader-site');
    });
    $(window).load(function() {
      $('.preloader-wrapper').hide();
      $('.collection-horizontal').removeClass('preloader-site');
    });
  },
  blogpage: function(){
    $('.viewMore').click(function(e){
      $('ul.view-more').show();
      $('ul.view-less').hide();
    });
    $('.viewLess').click(function(e){
      $('ul.view-more').hide();
      $('ul.view-less').show();
    });
  },
  // To Active Navigation (header)
  navigationMain:function(){
   $('.menu-list li.top-level-link').each(function(index,element){
      var $first = $(this);
      $first.find('.second-level-li').each(function(index,element){
        var $second = $(this);
        $second.find('.third-level-li').each(function(index,element){
          var $third = $(this);
          if($third.find('.fourth-level-li').length > 0){
          $third.find('.fourth-level-li').each(function(index,element){
            var $forth = $(this);
            if($forth.find('a').hasClass('active-li')){
              $third.find('a:first').addClass('active-li');
              $second.find('a:first').addClass('active-li');
              $first.find('a:first').addClass('active-li');
              $second.addClass('active');
              $second.siblings('.second-level-li').removeClass('active');
              var sl = $second.find('a:first').text().toLowerCase();
               if(sl.indexOf('iphone') > -1 || sl.indexOf('ipad') > -1 || sl.indexOf('iwatch') > -1 || sl.indexOf('ipod') > -1){
                sl = '<span class="without-capitalization">'+$second.find('a:first').text()+'</span>';
              }else{
                sl=$second.find('a:first').text();
              }

              var tl = $third.find('a:first').text().toLowerCase();
              if(tl.indexOf('iphone') > -1 || tl.indexOf('ipad') > -1 || tl.indexOf('iwatch') > -1 || tl.indexOf('ipod') > -1){
                tl = '<span class="without-capitalization">'+$third.find('a:first').text()+'</span>';
              }else{
                tl=$third.find('a:first').text();
              }


              var a = '<a class="brand" href = "'+$second.find('a:first').attr('href')+'">'+sl+'</a><a href="'+$third.find('a:first').attr('href')+'">'+tl+'</a>';
              if($('.breadcrumb .brand').length > 0){

              }else{
              	$('.breadcrumb span').before(a);
              }

            }
          });
          }else{

            if($third.find('a').hasClass('active-li-black')){
              $second.find('a:first').addClass('active-li');
              $first.find('a:first').addClass('active-li');
              $second.addClass('active');
              $second.siblings('.second-level-li').removeClass('active');
              var al = $.trim($first.find('a:first').text().toLowerCase());
              var fl = $first.find('a:first').text().toLowerCase();
              var sl = $second.find('a:first').text().toLowerCase();

              if(fl.indexOf('iphone') > -1 || fl.indexOf('ipad') > -1 || fl.indexOf('iwatch') > -1 || fl.indexOf('ipod') > -1){
                fl = '<span class="without-capitalization">'+$first.find('a:first').text()+'</span>';
              }else{
                fl=$first.find('a:first').text();
              }
              if(sl.indexOf('iphone') > -1 || sl.indexOf('ipad') > -1 || sl.indexOf('iwatch') > -1 || sl.indexOf('ipod') > -1){
                sl = '<span class="without-capitalization">'+$second.find('a:first').text()+'</span>';
              }else{
                sl=$second.find('a:first').text();
              }
              if(al == 'apple' || al == 'samsung'){
              	var a = '<a class="brand" href = "'+$first.find('a:first').attr('href')+'">'+fl+'</a><a class="brand" href = "'+$second.find('a:first').attr('href')+'">'+sl+'</a>';
              }else{
                var a = '<a class="brand" href = "'+$second.find('a:first').attr('href')+'">'+sl+'</a>';
              }
              if($('.breadcrumb .brand').length > 0){

              }else{
              	$('.breadcrumb span').before(a);
              }
            }
          }
        });
      });



    });

  },
  // Index Page
  // Custom Builder Back Button
  goback:function(){

    $('.selectAnotherRepairType').click(function(e){

      $('.gradient-bg').removeClass('open');
      $('.selectAnotherRepairType').closest('.pop-up-content').hide();
      totalProd=0;
      totalsAllProducts=0;
    });

    $(document).on('click', 'a#keep-explore', function (event) {
      event.preventDefault();
      $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 76
      }, 500);
    });

    $('#horizontalTab .pop-up-content').each(function(index,e){
      $('.go-backs',this).click(function(e){



        var preUrl = $(this).attr('data-prevname');

        if($(this).attr('data-prevname')){
          var url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
          var pushURL = url.toString().replace('/'+preUrl,'');
          window.history.replaceState({}, document.title, "/?" + pushURL);
        }

        var prevId = $(this).attr('data-previd');

        $('#horizontalTab').responsiveTabs('activate', prevId);
        if( prevId == '5'){

          $('#tab-5 #Quantity').val('1');
          $('#tab-6 .addons').each(function(index,element){
            $('.btnAddC',this).removeClass('Added');
            $('.btnAddC',this).val('+ Add');
          });
        }


      });
    });

    $('.device-issue span#viewMore').click(function(e){
      var $this = $(this);
      $('.device-issue .viewMore').toggleClass('open');
      if($('.device-issue .viewMore').hasClass('open')){
        $this.text('View Less');
      }
      else{
        $this.text('View More');
      }
      e.stopPropagation();
    });

    $('.view-more-popup-wrap.viewMore.open').click(function(e){
      $('.device-issue .viewMore').addClass('open');
      e.stopPropagation();
    });

    $(document).not('.view-more-popup-wrap.viewMore.open').click(function(e){
      $('.device-issue .viewMore').removeClass('open');
      $('.device-issue span#viewMore').text('View More');
      e.stopPropagation();
    });

    $('.firstColor .go-back').click(function(e){
      var $this = $(this);
      if($(this).data('goback') == 'home'){
        $this.closest('.pop-up-content').hide();
        $('.gradient-bg').removeClass('open');
        window.history.replaceState({}, document.title, "/");
      }
    });
  },

  //custom builder
  scrollToActive: function(){
    var obj = $('#horizontalTab_cust .r-tabs-state-active');
    var childPos = obj.offset();
    var parentPos = obj.parents('.resp-tabs-list').offset();
    var childOffset = {
      top: childPos.top - parentPos.top,
      left: childPos.left - parentPos.left
    }
    var currentScroll = $(".resp-tabs-list").scrollLeft();
    if($("#horizontalTab_cust li.r-tabs-state-active").index() > 2){
      $(".resp-tabs-list").animate({
        scrollLeft: currentScroll + childOffset.left
      });
      $('.back-link').show();
    }
  },

  //custom builder
  custoHorizontalCustomizer: function(){
    setTimeout(function(){
      $('#horizontalTab_cust .tab-desc').each(function(index,element){
        var $this = $(this);

        if($(window).width() > 1024){
          $('img.question',this).on('click, mouseover',function(e){
            e.stopPropagation();
            if($this.find('.tool-hover').hasClass('active')){
              $this.find('.tool-hover').fadeOut().removeClass("active");
            }else{
              $this.find('.tool-hover').fadeIn().addClass('active');
            }
          });
          $("body").on('click, mouseover',function(){
            $this.find('.tool-hover').fadeOut().removeClass("active");
          });
        }else{
          $('img.question',this).on('click, touchend',function(e){
            e.stopPropagation();
            if($this.find('.tool-hover').hasClass('active')){
              $this.find('.tool-hover').fadeOut().removeClass("active");
            }else{
              $this.find('.tool-hover').fadeIn().addClass('active');
            }
          });
          $("body").on('click, touchend',function(){
            $this.find('.tool-hover').fadeOut().removeClass("active");
          });
        }

      });
    },3000);

    setTimeout(function(){
    $('#horizontalTab_cust .swatch :radio').change(function() {
      var optionIndex = $(this).closest('.swatch').attr('data-option-index');
      var optionValue = $(this).val();
      $(this)
      .closest('form')
      .find('.single-option-selector')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');
    });

    var $tabs = $('#horizontalTab_cust');
    if($('#horizontalTab_cust .tabs').length > -1){
      var total = $('#horizontalTab_cust .tabs').length;
    }
    // if more than one options available @ that time tabination will be show
    if(total > 1){
      if($('#horizontalTab_cust').length >= 1){
        $tabs.responsiveTabs({
          active:1,
          rotate: false,
          startCollapsed: 'accordion',
          collapsible: 'accordion',
          setHash: false,
		  disabled: [1,2,3,4,5,6,7,8,9],
          click: function(e, tab) {

          },
          activate: function(e, tab) {

          },
          activateState: function(e, state) {

          }
        });
      }
    }
    $('#horizontalTab_cust ul li a:first').trigger('click');


    if($('.tab-desc')){
    var mainTabLength = $('.tab-desc').length;
    }
    $('.button-wrap .SkipSummary').click(function(e){
      var summary = "";
      $('input[type=radio]:checked').each(function(index, element) {
        var dataSummary = $(this).data('summary');
        var dataValue = $(this).data('value');
        summary += '<p><span>'+dataSummary+': </span> '+dataValue+'</p>';
      });
      /* for goto insurance */
      for(var i=0; i<(mainTabLength); i++){
        $tabs.responsiveTabs('enable', i);
        $('.resp-tabs-list li').each(function(index,e){
          var $tb = $(this);
          var $dataId = $(this).attr('data-id');
          if($dataId.indexOf('insurance') > -1){
            $tb.find('a').click();
          }
        });
        repairsUniverse.scrollToActive();
      }
    });

    var summary = "";

    $('#horizontalTab_cust .tab-desc').each(function(index, element) {
      var $tabIndex = index;
      var $tabthis = $(this);

      $tabthis.find('input[type=radio]').each(function(index, element) {
        $(this).click(function(e) {
          var $this = $(this);
          var val = $this.val();

          if(($tabIndex+1) == mainTabLength){
            var summary = "";
            $('form#AddToCartForm input[type=radio]:checked').each(function(index, element) {



              var dataSummary = $(this).data('summary');
              var dataValue = $(this).data('value');
              summary += '<p><span>'+dataSummary+': </span> '+dataValue+'</p>';
            });
            $('.withTab').addClass('hide');
            $('.withoutTab').removeClass('hide');
            $('.withoutTab .summary').html(summary);
            $('#Quantity').show();
            $('.button-wrap .SkipSummary').hide();
            $('.button-wrap .addToCart').show();
            $('.button-wrap .addToCart').removeClass('disabled-btn');
          }else{
            var tabInd = 0;
            var $newId = $tabthis.attr('id');
            //to get next inedx
            $('.resp-tabs-list li').each(function(index,element){
              if($(this).attr('data-id') == $newId){
                tabInd = index;
              }
            });
            //for checking next is smallpart or not
            if($newId.indexOf('small-part') > -1){
              if(val.indexOf('Without') > -1){
                $tabs.responsiveTabs('enable', tabInd+1);
                $('.resp-tabs-list .'+$newId).next('li').find('a').click();
                $('.resp-tabs-list .'+$newId).next('li').next('li').find('a').removeClass('withsmall');
              }else{
                var chckQual = $('.resp-tabs-list .'+$newId).next('li').attr('data-id');
                if(chckQual.indexOf('quality') > -1){
                  //to default check Aftermarket
                  var value = 'Aftermarket';
                  $("input[name=option-1][value=" + value + "]").click();
                  // for go to next to next
                  $('.resp-tabs-list .'+$newId).next('li').next('li').find('a').addClass('withsmall');
                  $tabs.responsiveTabs('enable', tabInd+2);
                  $('.resp-tabs-list .'+$newId).next('li').next('li').find('a').click();
                  $('.resp-tabs-list .'+$newId).next('li').next('li').find('a').trigger('click');
                }else{
                  $tabs.responsiveTabs('enable', tabInd+1);
                  $('.resp-tabs-list .'+$newId).next('li').find('a').click();
                }
              }
            }else{
              //if no small parts will goto next
              $tabs.responsiveTabs('enable', tabInd+1);
              $('.resp-tabs-list .'+$newId).next('li').find('a').click();
            }

            $('.button-wrap .addToCart').hide();
            $('.button-wrap .SkipSummary').show();
            $('#Quantity').show();
            repairsUniverse.scrollToActive();

          }
          $('.qua-name').responsiveEqualHeightGrid();
          $('.quality-inner img').responsiveEqualHeightGrid();
          $('.quality-inner p').responsiveEqualHeightGrid();
          $('.thumb-desc-wrp').responsiveEqualHeightGrid();
          $('.desc h5').responsiveEqualHeightGrid();
          $('.desc p').responsiveEqualHeightGrid();
        });
      });
    });

    $('.back-link').click(function(e) {
      var a = $('#horizontalTab_cust ul.resp-tabs-list li.r-tabs-state-active').index();
      var chksmall = false;

      if($(window).width() > 767){
        if($('#horizontalTab ul.resp-tabs-list li.r-tabs-state-active a').hasClass('withsmall')){
          chksmall = true;
        }
      }else{
		if($('#horizontalTab ul.resp-tabs-list li.r-tabs-state-active a').hasClass('withsmall')){
          chksmall = true;
        }
      }
      if(a > 0){
        if(chksmall == true){
          $tabs.responsiveTabs('enable', a-2);
          $tabs.responsiveTabs('activate', a-2);
          var obj = $('#horizontalTab .r-tabs-state-active');
          var childPos = obj.offset();
          var parentPos = obj.parents('.resp-tabs-list').offset();
          var childOffset = {
            top: childPos.top - parentPos.top,
            left: childPos.left - parentPos.left
          }
          var currentScroll = $("#horizontalTab  .resp-tabs-list").scrollLeft();
          $("#horizontalTab .resp-tabs-list").animate({
            scrollLeft: currentScroll + childOffset.left
          });
        }
        else{
          $tabs.responsiveTabs('enable', a-1);
          $tabs.responsiveTabs('activate', a-1);
          var obj = $('#horizontalTab_cust .r-tabs-state-active');
          var childPos = obj.offset();
          var parentPos = obj.parents('.resp-tabs-list').offset();
          var childOffset = {
            top: childPos.top - parentPos.top,
            left: childPos.left - parentPos.left
          }
          var currentScroll = $("#horizontalTab_cust  .resp-tabs-list").scrollLeft();
          $("#horizontalTab_cust .resp-tabs-list").animate({
            scrollLeft: currentScroll + childOffset.left
          });
        }

        $('.back-link').show();
      }
      else{
        $('.back-link').hide();
      }
      if(a == 1){
        $('.back-link').hide();
      }
    });

    $('.back-link-without').click(function(e){
      $('.withTab').removeClass('hide');
      $('.withoutTab').addClass('hide');
    });

    $('#AddToCart').on('click',function(e){

      var popD = $(this).closest('.pop-up-content');
      var indexD = parseInt(popD.attr('data-index'));



      totalProd=0;
      var $thisAddCart = $(this);
     // $thisAddCart.text('Adding..');
      $thisAddCart.attr('disabled','disabled');
      $thisAddCart.addClass('disabled-btn');
     // $('body').addClass('productPopupActive');
      if($('.tab-desc').length <= 0){
        var qtyC = parseInt($('#Quantity').val());
        if(qtyC == 1){
          $('.maincount').html(qtyC +' item');
        }else{
          $('.maincount').html(qtyC +' items');
        }
      }
      var qtyC = parseInt($('#Quantity').val());
      if(qtyC == 1){
        $('.maincount').html(qtyC +' item');
      }else{
        $('.maincount').html(qtyC +' items');
      }
      var count =1;

      $('.popup.product-popup').show();
      $('.popup.product-popup#resultPopup').addClass('resultPopup');


      var Qty = $('#Quantity').val();
      $('.mainQty').text('Qty: '+Qty);

      $('.product-cart h4.price').text(mainPrice);

      var varintId = mainVarinat;
      var data_ajax = {
        "quantity": Qty,
        "id": varintId
      }
      var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: data_ajax,
        dataType: 'json',
        async:false,
        success: function(line_item) {
          repairsUniverse.quickviewUpdateCartCustom();
        },
        error: function(er) {
          var err = $.parseJSON(er.responseText);
          return false;
        }
      }
      $.ajax(params);

      totalsAllProducts += parseInt(Qty);

      mainArrayAllProducts[varintId]=Qty;


      $('.popup .sub-product').html('');
      productQty = $('#Quantity').val();
      count = parseInt(productQty);
      $('.without-swatch input[type=radio]:checked').not('.swatch input[type=radio]:checked').each(function(index, element) {
        if($(this).data('handle')){
          var product_handle = $(this).data('handle');
          var Qty = 1;
          var varintId = $(this).val();
          var product_id = $(this).val();
          Shopify.getProduct(product_handle, function(product) {
            var addProduct = '';
            count += 1;
            var productTitle = product.title;
            var productType = product.type;
            var v = '';
            for(var i in product.variants){

              if(product.variants[i].id == product_id){
                if(product.variants[i].title != 'Default Title'){
                  v = product.variants[i].title;
                }
              }
            }

            var price = Shopify.formatMoney(product.price, window.money_format);
            addProduct += '<div class="sub-product-inner clearfix">';

            addProduct += '<div class="content">';
            addProduct += '<h6>'+productType+': <span>'+productTitle+' '+v+' ('+price+')</span></h6>';

            addProduct += '</div></div>';
            $('.popup .sub-product').append(addProduct);

            if(count == 1){
              $('.maincount').html(count +' item');
            }else{
              $('.maincount').html(count +' items');
            }

          });






          var Qty = 1;
          var varintId = $(this).val();

          totalsAllProducts += 1;


          var data_ajax = {
            "quantity": Qty,
            "id": varintId
          }
          var params = {
            type: 'POST',
            url: '/cart/add.js',
            data: data_ajax,
            dataType: 'json',
            async:false,
            success: function(line_item) {
              repairsUniverse.quickviewUpdateCartCustom();

            },
            error: function(er) {
              var err = $.parseJSON(er.responseText);
              return false;
            }
          }
          $.ajax(params);
          repairsUniverse.quickviewUpdateCartCustom();

        }
      });


      if($(window).width() > 767){
        $('.pop-up-prod-wrap .product-name').responsiveEqualHeightGrid();
      }



      setTimeout(function(e){
        $thisAddCart.text('Added!!');
        $thisAddCart.removeAttr('disabled');
        $thisAddCart.removeClass('disabled-btn');
        repairsUniverse.quickviewUpdateCartCustom();

      },500);
      setTimeout(function(e){
        $thisAddCart.text('Add To Cart');
        $thisAddCart.removeAttr('disabled');
        $thisAddCart.removeClass('disabled-btn');
        repairsUniverse.quickviewUpdateCartCustom();

        $('.productCollectionPopupFirst .close').click(function(e){
          $('.productCollectionPopupFirst').fadeOut();
          $('body').removeClass('productPopupActive');
        });

        repairsUniverse.viewMoredetail();



      },4000);
      e.preventDefault();
      jQuery.getJSON('/cart.js', function (cart, textStatus) {

        var freeship = parseInt('40');
                                var free2dayship = parseInt('1000');
                                var mprice =  parseFloat(Shopify.formatMoney(cart.total_price,window.money_format).replace('$','').replace(',',''));

        

        if(mprice < freeship){
          var remaining = parseFloat(freeship) - parseFloat(mprice);
          $('.side-shipping .continue-shopping .freeShippingText').text('FREE SHIPPING? Add $'+remaining.toFixed(2)+' more.');
        }else if(mprice < free2dayship){
          $('.side-shipping .continue-shopping .freeShippingText').text('Product ships free!');
        }

        /*var freeship = parseInt('50');
        var mprice =  parseFloat(Shopify.formatMoney(cart.total_price,window.money_format).replace('$','').replace(',',''));

        if(mprice < freeship){
          var remaining = parseFloat(freeship) - parseFloat(mprice);
          remaining = remaining.toFixed(2);

          $('.side-shipping .continue-shopping .freeShippingText').text('Add $'+remaining+' more for FREE SHIPPING!');
        }
        else if(mprice > freeship){
          $('.side-shipping .continue-shopping .freeShippingText').text('Free shipping');
        }
        else{
          $('.side-shipping .continue-shopping .freeShippingText').text('Free shipping');
        }*/

      });


      popD.hide();



      $('#horizontalTab').responsiveTabs('activate', indexD+1);
      $('#horizontalTab').responsiveTabs('enable', indexD+1);



    });



     $('body').on('mouseover','.resp-tabs-container .input-label-wrap',function(e){
      var tooltip = $('input[type=radio]',this).attr('data-tooltip');
      if($.trim(tooltip) != ''){
        $('.tooltip-container').html(tooltip);
        $('.tooltip-container').addClass('open');
      }else{
        $('.tooltip-container').html('');
        $('.tooltip-container').removeClass('open');
      }
    });
    $('body').on('mouseout','.resp-tabs-container .input-label-wrap',function(e){
      $('.tooltip-container').html('');
      $('.tooltip-container').removeClass('open');
    });
    },1000);
  },

  //custom builder
  quickviewUpdateCartCustom: function(){
    jQuery.getJSON('/cart.js', function (cart, textStatus) {
      $('body').find('#CartCount').html(cart.item_count);
      if($(window).width() < 1024){
        $('.mean-bar #CartCount').html(cart.item_count);
      }else{
        $("#CartCount").html(cart.item_count);
      }
    });
  },

  //custom builder
  customSelectCallBack: function(variant, selector) {
    if (variant) {
      mainVarinat = variant.id;
      mainPrice = Shopify.formatMoney(variant.price);
      $('span.meta-sku').text(variant.sku);
      if(variant.title != 'Default Title'){
        $('.metaVariant').text(variant.title);
      }
      var form = jQuery('#' + selector.domIdPrefix).closest('form');
      for (var i = 0, length = variant.options.length; i < length; i++) {
        var radioButton = form.find(".swatch[data-option-index='" + i + "'] :radio[value='" + variant.options[i] + "']");
        if (radioButton.size()) {
          radioButton.get(0).checked = true;
        }
      }
    }
    timber.productPage({
      money_format: "",
      variant: variant,
      selector: selector
    });
  },
  // Index page
  // Custom builder
  buttonclick: function(data){
    if(data.hasClass('thumb-desc-wrp')){
      $('.withColor_customProductList_variant .partindi').each(function(index,e){
        var $this = $(this);
        if($(this).hasClass(mainId+'-indi')){
          $('.page-sub-heading').show();
          $this.show();
        }else{
          $this.hide();
        }
      });
    }
  },

  getFromURLCustomBanner: function(){
    if(window.location.href.indexOf('?') > -1){
      var pathname = window.location.href.split('?');
      var pages = pathname[1].replace('page=','');
      var uniquetabs = pages.split('/');
      setTimeout(function(){
        for(var i in uniquetabs){

          if(i==0){

            $('.banner-inner li').each(function(index,e){
              var $this = $(this);
              if($('.circleBox',this).attr('data-maintitle') == uniquetabs[i]){
                $this.find('.circleBox').trigger('click');
              }
            });

          }
          if(i==1){
            $('#horizontalTab .pop-up-content .device-wrap a[data-id="'+uniquetabs[i]+'"]').trigger('click');

            setTimeout(function(){
              $('#horizontalTab .pop'+i).hide();
            },1000);
          }
          if(i == 2){

            $('#horizontalTab .pop-up-content .device-wrap a[data-id="'+uniquetabs[i]+'"]').trigger('click');

            setTimeout(function(){
              $('#horizontalTab .pop'+i).hide();
              $('#horizontalTab .pop'+(i-1)).hide();
            },1000);
          }


        }
      },2000);
    }
  },

  customMobileBanner:function(){
    var totalItem_mobile = 0;
    var varArray_mobile = [];

    $('body').on('click','.selectAnotherRepairType-mobile', function(e){
      $('#custom-banner-mobile').hide();
      $('.PopupBox').removeClass('open');
      $('.steps-levels .level').removeClass('active');
      $('.all-last-pops').addClass('hide');
      $('.main-accodian-tabs').removeClass('hide');
      $('.accordian-li.color-level-li').hide();
      $('.accordian-li.brand-level-li').siblings('.accordian-li').addClass('disabled');

    });

    $("#custom-banner-mobile .toggles").click(function (e) {
      e.preventDefault();
      var $this = $(this);
      if ($this.next().hasClass("show1")) {
        $this.next().removeClass("show1");
        $this.next().slideUp(350);
      } else {
        $this
        .parent()
        .parent()
        .find("li .inner")
        .removeClass("show1");
        $this
        .parent()
        .parent()
        .find("li .inner")
        .slideUp(350);
        $this.next().toggleClass("show1");
        $this.next().slideToggle(350);
      }
    });

    $('body').on('click','.circleBox', function(){

      console.log('mobile clck');

      var anchor = $(this).attr('data-href');
      mainTag =  $(this).attr('data-maintitle');
      $('#circleBox .repair-texts').text(mainTag+' repair');
      $(this).next().addClass("open");
      setTimeout(function () {
        $(anchor).fadeIn();
        $("#custom-banner-mobile").show();
        $('.pop-up-content a.toggle').removeClass('open');
        $('.pop-up-content ul.inner').removeClass('show1');
        $('.pop-up-content ul.inner').hide();

        if($('ul .accordian-li:first a.toggle').hasClass('open') == false){
          $('ul .accordian-li:first a.toggle').click();
        }
        //$('.accordion-custom-banner li:first a').trigger('click');

      }, 1000);

      $('body').addClass('open-custombanner');
      $('.main-repair-type').text(mainTag+' repair');

      //dockport home-button screen

      if(mainTag == 'dockport' || mainTag == 'home-button' || mainTag == 'screen'){
      $('#custom-banner-mobile').attr('data-maintag','main-color');
      }else{
        $('#custom-banner-mobile').removeAttr('data-maintag');
      }
      pushState = "?page="+mainTag;

      var type='';
      if(mainTag == 'screen'){
        type = "Mate 9,S3,Honor 7X,G Stylo,A9 (A900),G4,S8 Active G892,Evo 3D,Macbook";
      }
      else if(mainTag == 'dockport'){
        type = "iPad 1,Watch,Macbook,Galaxy A,Galaxy J,htc,Nexus 9,Nexus 7 (2013),Nexus 7,LG V20,LG V10,Nexus 5x,Motorola,Zenfone 2,Zenfone 3,Zenfone 3 Deluxe 5.5 inch,Zenfone 3 Deluxe 5.7 inch,Honor 9,Honor 8,Mate,Essential,Tablet,S3,Moto X,G Stylo,Nexus 5x,A9 (A900),G4,S8 Active G892,iPhone 3G,Note I";
      }
      else if(mainTag == 'battery'){
        type = "iPhone 3GS,iPhone 3G,iPad 1,iPod Touch 5th Gen,iPod Touch 4th Gen,iPod Nano 7th Gen,iPod Nano 5th Gen,iPod Nano 3rd Gen,S5 Active,A8,A7 - A700,A5 A520,A5 - A500,J7 (J727 / 2017),J7 - J700,J3 J330 (2017),J3 (2016) J320,htc,Nexus 9,Nexus 7 (2013),Nexus 7,OnePlus One,OnePlus 2,OnePlus 3,OnePlus 3T,Oneplus X,Moto G,Moto G (2015),Moto G 4th Gen 2016,Moto G4 Play,Moto G4 Plus (2016),Z Series,E Series,Zenfone 3,Zenfone 3 Deluxe 5.5 inch,Zenfone 3 Deluxe 5.7 inch,Zenfone Max,Mate 9,Essential,Tablet,Honor 7X,Moto X (2nd Gen),Moto X Play,Moto X Pure,Moto X Style,G Stylo,Nexus 5x,A9 (A900),G4,S8 Active G892,Note I";
      }
      else if(mainTag == 'home-button'){
        type = "iPhone XS Max,iPhone XS,iPhone XR,iPhone X,iPhone 5c,iPhone 5,iPad Pro 12.9 (2017),iPad Air,iPad 4,iPad 3,iPad 2,iPad 1,iPad Mini 4,iPad Mini 3,iPad Mini 2 (Retina),iPad Mini,iPod Touch 6th Gen,iPod Touch 5th Gen,iPod Touch 4th Gen,iPod Touch 3rd Gen,iPod Touch 2nd Gen,iPod Nano 7th Gen,iPod Nano 6th Gen,iPod Nano 5th Gen,iPod Nano 4th Gen,iPod Nano 3rd Gen,iPod Classic 6th Gen,Watch,Macbook,S3,Honor 7X,Moto X,G Stylo,Nexus 5x,Nexus 5,A9 (A900),G4,Nexus 4 E960,S8 Active G892,Note I";
      }
      else if(mainTag == 'camera'){
        type = "iPhone 4,iPhone 3GS,iPhone 3G,Essential,Tablet,Honor 5X,Mate 10,Asus,Droid Ultra,Moto G (2014),Moto G (2015),Moto X Play,Moto E (2nd Gen),Moto E (3rd Gen),Moto E (3rd Gen) Power,OnePlus 2,OnePlus 3,OnePlus 3T,Oneplus X,K Series,Stylo 3,Nexus 4 E960,Nexus 9,Nexus 7 (2013),Nexus 7,Nexus 4,U Play,U Ultra,Desire 10 Pro,Bolt,HTC First,Evo 3D,J7 (J727 / 2017),J7 Prime,J3 (2016) J320,J3 J330 (2017),A7 - A700,A5 A520,A3 (A300),S5 Active,Watch,Macbook,iPod Touch 6th Gen,iPod Touch 5th Gen,iPod Touch 3rd Gen,iPod Touch 2nd Gen,iPod Nano 7th Gen,iPod Nano 6th Gen,iPod Nano 5th Gen,iPod Nano 4th Gen,iPod Nano 3rd Gen,iPod Classic 6th Gen,iPad 1,S3,Moto X,Nexus 4 E960,S8 Active G892,Note I";
      }
      else if(mainTag == 'speaker'){
        type = "Watch,Macbook,iPod,iPad 1,iPhone 3GS,iPhone 3G,S3,Honor 7X,Essential,Tablet,Mate 10,Zenfone 2,Zenfone 3,Zenfone 3 Deluxe 5.5 inch,Zenfone 3 Deluxe 5.7 inch,Droid Series,Moto G (2014),Moto G (2015),Moto G4 Play,Moto X (2nd Gen),Moto X Play,Moto E,Moto E (2nd Gen),Moto E (3rd Gen),OnePlus One,OnePlus 3T,K Series,Stylo 3,Nexus 9,Nexus 7 (2013),Nexus 7,htc,Note II,A9 (A900),S5 Active,A7 - A700,A5 A520,A5 - A500,A3 (A300),J7 (J727 / 2017),J7 - J700,J7 J710,J7 Prime,J3 (2016) J320,J3 J330 (2017),G4,Note I";
      }
      var sp = type.split(',');
      for(var i=0;i<sp.length;i++){
        var spl = sp[i].toLowerCase();
        $('.accordion-custom-banner a').each(function(index,e){
          var $this = $(this);
          if($.trim($this.text().toLowerCase()) == $.trim(spl)){
            $this.parent('li').hide();
            $this.parent().parent('li').hide();
          }
        });
      }

    // $('.accordion-custom-banner li:first a').trigger('click');

    //  window.history.pushState('test', 'Title', pushState);
    });

    $('body').on('click','.main-repair-type',function(e){
      $('.circleBox').next().removeClass('open');
      $('body').removeClass('open-custombanner');
      $("#custom-banner-mobile").hide();
      $('.accordion-custom-banner a').each(function(index,e){
         var $this = $(this);
        $this.parent('li').show();
        $this.parent().parent('li').show();
      });
    });

    $('body').on('click','.change-modal h2',function(e){


      $('.all-last-pops').addClass('hide');
      $('.main-accodian-tabs').removeClass('hide');

      if($('ul .accordian-li:first a.toggle').hasClass('open') == false){
        $('ul .accordian-li:first a.toggle').click();
      }
    });

    $('body').on('click','.accordian-li li a', function(e){

      var $this = $(this);
      var $parent = $(this).closest('.accordian-li');
      if($(this).attr('data-id')){

        if($parent.hasClass('brand-level-li')){
          if(mainTag == 'dockport' || mainTag == 'home-button' || mainTag == 'screen'){
            if($this.data('id') == 'samsung'){
              $('.accordian-li.color-level-li').show();
              $('#custom-banner-mobile').attr('data-brandmodel','color-model');
            }else{
              $('.accordian-li.color-level-li').hide();
              $('#custom-banner-mobile').removeAttr('data-brandmodel');
            }
          }
        }
        if($parent.hasClass('device-level-li')){
          if(mainTag == 'dockport' || mainTag == 'home-button' || mainTag == 'screen'){
            if($this.data('id') == 'iphone' || $this.data('id') == 'ipad'){
              $('.accordian-li.color-level-li').show();
              $('#custom-banner-mobile').attr('data-devicemodel','color-model');
            }else{
              if($('#custom-banner-mobile').attr('data-brandmodel')){
                $('.accordian-li.color-level-li').show();
              }else{
                $('.accordian-li.color-level-li').hide();
                $('#custom-banner-mobile').removeAttr('data-devicemodel');
              }
            }
          }
        }


        $parent.find('a.toggle').removeClass('open');
        $parent.find('ul.inner').hide().removeClass('show1');
        $parent.next('.accordian-li').removeClass('disabled');


        //for display next
        $parent.next('.accordian-li').find('a.toggle').click();
        $parent.next('.accordian-li').find('.pops.pop-'+$this.attr('data-id')).show();
        $parent.next('.accordian-li').find('.pops.pop-'+$this.attr('data-id')).siblings('.pops').hide();

        //add color tab for dock-port, screen,home-button : iPhone, iPad, Smasung all
        if($this.attr('data-link')){





          var $url = $this.attr('data-link')+'/'+mainTag+'?view=customBanner';
          $('.withColor_customProductList_variant').html('<img alt="Loading Icon" src="//cdn.shopify.com/s/files/1/2305/6727/files/repairs__loader.gif?6462" class="loading_image"><h3 class="locating-part">Locating correct part for your repair</h3>');
          $('.main-accodian-tabs').addClass('hide');
          $('.all-last-pops').removeClass('hide');

          var $mainUrlu = $(this).attr('data-link');
          if($mainUrlu.indexOf('/products') > -1){

            window.history.pushState('test', 'Title', pushState);
            window.location.href = $mainUrlu;
          }else{

            $.ajax({
              type:"GET",
              url: $url,
              success: function(data){
                if($.trim($(data).find('.customProductList').html()) != ''){
                  if($(data).find('.customProductList .popDevice').length == 1){
                    var $link  = $(data).find('.customProductList .popDevice .collectionPage').attr('data-mainurlid');
                    window.location.href = $link;
                  }else{
                    $('.main-accodian-tabs').addClass('hide');
                    $('.all-last-pops').removeClass('hide');
                    $('.withColor_customProductList_variant').html($(data).find('.customProductList').html());
                  }
                }else{
                  $('.withColor_customProductList_variant').html('<div class="no-Products"><p class="noProducts">No products available</p></div>');
                }
              }
            });
          }
        }
      }
    });

    $('body').on('click','a.collectionPage',function(e){
      var $url = $(this).attr('data-product');
      var handleId = $(this).attr('id');
      $('.pop-up-content-inner.level-1').addClass('hide');
      $('.pop-up-content-inner.level-2').removeClass('hide');
      $('.pop-up-content-inner.level-2 .selected-pop').html('<img alt="Loading Icon" src="//cdn.shopify.com/s/files/1/2305/6727/files/repairs__loader.gif?6462" class="loading_image"><h3 class="locating-part">Locating correct part for your repair</h3>');
      $('.steps-levels .level-2').addClass('active');

      $.ajax({
        type: "GET",
        url: $url,
        success: function (data) {

        }
      });

    });

    $('body').on('click','.pop-up-content-inner.level-2 .addCartBtnWrap a#AddToCart',function(e){
      var variantId = $(this).attr('data-variantid');
      var qty = $('.pop-up-content-inner.level-2 #Quantity').val();
      totalItem_mobile += 1;
      var data_ajax = {
        "quantity": qty,
        "id": variantId
      }
      var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: data_ajax,
        dataType: 'json',
        async: false,
        success: function (line_item) {

        },
        error: function (er) {
          var err = $.parseJSON(er.responseText);
          return false;
        }
      }
      $.ajax(params);
      jQuery.getJSON('/cart.js', function (cart, textStatus) {
        $('body').find('#CartCount').html(cart.item_count);
        if ($(window).width() <= 1024) {
          $('.mean-bar #CartCount').html(cart.item_count);
        } else {
          $("#CartCount").html(cart.item_count);
        }
      });
      $('.pop-up-content-inner.level-2').addClass('hide');
      $('.pop-up-content-inner.level-3').removeClass('hide');
      $('.steps-levels .level-3').addClass('active');

    });

    $('body').on('click','.pop-up-content-inner.level-3 .btnAddC', function (e) {
      $(this).addClass('Added');
      $(this).val('added');
      var variant = $(this).attr('data-variantid');
      var qty = 1;
      varArray_mobile.push(variant);

    });

    $('body').on('click','.pop-up-content-inner.level-3 #addOnsAddTocart', function (e) {
       $(this).addClass('disabled');
      var tots = varArray_mobile.length;
      totalItem_mobile += tots;
      var AllProduct = [];
      var uniqueArray = $.unique(varArray_mobile);
      for (var j in uniqueArray) {
        var variant = uniqueArray[j];
        AllProduct.push({
          variant_id: variant,
          quantity_id: 1,
        });
      }

      for (var i in AllProduct) {
        var tempId = AllProduct[i].variant_id;
        var tempQty = AllProduct[i].quantity_id;
        var data_ajax = {
          "quantity": tempQty,
          "id": tempId
        }

        var params = {
          type: 'POST',
          url: '/cart/add.js',
          data: data_ajax,
          dataType: 'json',
          async: false,
          success: function (line_item) {

          },
          error: function (er) {
            var err = $.parseJSON(er.responseText);
            return false;
          }
        }
        $.ajax(params);
      }
      jQuery.getJSON('/cart.js', function (cart, textStatus) {
        $('body').find('#CartCount').html(cart.item_count);
        if ($(window).width() <= 1024) {
          $('.mean-bar #CartCount').html(cart.item_count);
        } else {
          $("#CartCount").html(cart.item_count);
        }
      });
      if (totalItem_mobile == 1) {
        $('.last-ready.level-4 span.cart-total').text(totalItem_mobile + ' item was added to your cart');
      }else{
        $('.last-ready.level-4 span.cart-total').text(totalItem_mobile + ' item was added to your cart');
      }
      $('.pop-up-content-inner.level-3').addClass('hide');
      $('.last-ready.level-4').removeClass('hide');
      $('.steps-levels .level-4').addClass('active');
      $(this).removeClass('disabled');
    });

  },

  customRemoval:function(mainTag){
    $('#horizontalTab .pop3 .popDevice, #horizontalTab .pop2 .popDevice').each(function(index,element){
      var $pop3This = $(this);
      var $dataPopID = $(this).attr('data-popid');
      var totalLength = $('.button-wrap',this).length;
      var count = 0;
      $('.button-wrap',this).each(function(index,element){

        var $this = $(this);
        if($('a',this).attr('data-link')){
          var $url = $('a',this).attr('data-link')+'/'+mainTag+'?view=customBanner';

          $.ajax({
            type:"GET",
            url: $url,
            success: function(data){
              if($.trim($(data).find('.customProductList').html()) == ''){
                count++;
                $this.hide();
                if(totalLength == count){

                  $('.button-wrap.'+$dataPopID).hide();
                }else{
                  $('.button-wrap.'+$dataPopID).show();
                }
              }else{
                $this.show();
                $('.button-wrap.'+$dataPopID).show();
              }
            }
          });
        }
      });


    });

  },

  customNewBanner:function(){
    var i = 0;
    var pushState = '';
    var mainid='';
    //when click on circlebox
    $('body').on('click','.circleBox', function(){

      $(this).next('.PopupBox').addClass("open");
      $('.button-wrap').show();
      $('.button-wrap').show();
      var anchor = $(this).attr('data-href');

      setTimeout(function () {
        $(anchor).fadeIn();
        $('.pop-up-content-inner .device-wrap .button-wrap .device-btn-individual').responsiveEqualHeightGrid();
      }, 1000);
      mainTag =  $(this).attr('data-maintitle');
      $('#horizontalTab').attr('data-repair',mainTag);
      $('#circleBox .repair-texts').text(mainTag+' repair');

      $('.pop-up-content-inner .device-wrap .button-wrap .device-btn-individual').responsiveEqualHeightGrid();

      pushState = "?page="+mainTag;
      window.history.pushState('test', 'Title', pushState);


      var mainvariantI = "?page="+mainTag;
      $('#circleBox .go-back').attr('data-prevName',mainvariantI);
      var type='';
      if(mainTag == 'screen'){
        type = "Mate 9,S3,Honor 7X,G Stylo,A9 (A900),G4,S8 Active G892,Evo 3D,Macbook";
      }
      else if(mainTag == 'dockport'){
        type = "iPad 1,Watch,Macbook,Galaxy A,Galaxy J,htc,Nexus 9,Nexus 7 (2013),Nexus 7,LG V20,LG V10,Nexus 5x,Motorola,Zenfone 2,Zenfone 3,Zenfone 3 Deluxe 5.5 inch,Zenfone 3 Deluxe 5.7 inch,Honor 9,Honor 8,Mate,Essential,Tablet,S3,Moto X,G Stylo,Nexus 5x,A9 (A900),G4,S8 Active G892,iPhone 3G,Note I";
      }
      else if(mainTag == 'battery'){
        type = "iPhone 3GS,iPhone 3G,iPad 1,iPod Touch 5th Gen,iPod Touch 4th Gen,iPod Nano 7th Gen,iPod Nano 5th Gen,iPod Nano 3rd Gen,S5 Active,A8,A7 - A700,A5 A520,A5 - A500,J7 (J727 / 2017),J7 - J700,J3 J330 (2017),J3 (2016) J320,htc,Nexus 9,Nexus 7 (2013),Nexus 7,OnePlus One,OnePlus 2,OnePlus 3,OnePlus 3T,Oneplus X,Moto G,Moto G (2015),Moto G 4th Gen 2016,Moto G4 Play,Moto G4 Plus (2016),Z Series,E Series,Zenfone 3,Zenfone 3 Deluxe 5.5 inch,Zenfone 3 Deluxe 5.7 inch,Zenfone Max,Mate 9,Essential,Tablet,Honor 7X,Moto X (2nd Gen),Moto X Play,Moto X Pure,Moto X Style,G Stylo,Nexus 5x,A9 (A900),G4,S8 Active G892,Note I";
      }
      else if(mainTag == 'home-button'){
        type = "iPhone XS Max,iPhone XS,iPhone XR,iPhone X,iPhone 5c,iPhone 5,iPad Pro 12.9 (2017),iPad Air,iPad 4,iPad 3,iPad 2,iPad 1,iPad Mini 4,iPad Mini 3,iPad Mini 2 (Retina),iPad Mini,iPod Touch 6th Gen,iPod Touch 5th Gen,iPod Touch 4th Gen,iPod Touch 3rd Gen,iPod Touch 2nd Gen,iPod Nano 7th Gen,iPod Nano 6th Gen,iPod Nano 5th Gen,iPod Nano 4th Gen,iPod Nano 3rd Gen,iPod Classic 6th Gen,Watch,Macbook,S3,Honor 7X,Moto X,G Stylo,Nexus 5x,Nexus 5,A9 (A900),G4,Nexus 4 E960,S8 Active G892,Note I";
      }
      else if(mainTag == 'camera'){
        type = "iPhone 4,iPhone 3GS,iPhone 3G,Essential,Tablet,Honor 5X,Mate 10,Asus,Droid Ultra,Moto G (2014),Moto G (2015),Moto X Play,Moto E (2nd Gen),Moto E (3rd Gen),Moto E (3rd Gen) Power,OnePlus 2,OnePlus 3,OnePlus 3T,Oneplus X,K Series,Stylo 3,Nexus 4 E960,Nexus 9,Nexus 7 (2013),Nexus 7,Nexus 4,U Play,U Ultra,Desire 10 Pro,Bolt,HTC First,Evo 3D,J7 (J727 / 2017),J7 Prime,J3 (2016) J320,J3 J330 (2017),A7 - A700,A5 A520,A3 (A300),S5 Active,Watch,Macbook,iPod Touch 6th Gen,iPod Touch 5th Gen,iPod Touch 3rd Gen,iPod Touch 2nd Gen,iPod Nano 7th Gen,iPod Nano 6th Gen,iPod Nano 5th Gen,iPod Nano 4th Gen,iPod Nano 3rd Gen,iPod Classic 6th Gen,iPad 1,S3,Moto X,Nexus 4 E960,S8 Active G892,Note I";
      }
      else if(mainTag == 'speaker'){
        type = "Watch,Macbook,iPod,iPad 1,iPhone 3GS,iPhone 3G,S3,Honor 7X,Essential,Tablet,Mate 10,Zenfone 2,Zenfone 3,Zenfone 3 Deluxe 5.5 inch,Zenfone 3 Deluxe 5.7 inch,Droid Series,Moto G (2014),Moto G (2015),Moto G4 Play,Moto X (2nd Gen),Moto X Play,Moto E,Moto E (2nd Gen),Moto E (3rd Gen),OnePlus One,OnePlus 3T,K Series,Stylo 3,Nexus 9,Nexus 7 (2013),Nexus 7,htc,Note II,A9 (A900),S5 Active,A7 - A700,A5 A520,A5 - A500,A3 (A300),J7 (J727 / 2017),J7 - J700,J7 J710,J7 Prime,J3 (2016) J320,J3 J330 (2017),G4,Note I";
      }
      var sp = type.split(',');
      for(var i=0;i<sp.length;i++){
        var spl = sp[i].toLowerCase();
        $('a.btn-ghost').each(function(index,e){
          var $this = $(this);
          if($.trim($this.text().toLowerCase()) == $.trim(spl)){
            $this.parent('.button-wrap').hide();
            $this.parent().parent('.button-wrap').hide();
          }
        });
      }



      //repairsUniverse.customRemoval(mainTag);

    });

    //tabination added
    var $tabs = $('#horizontalTab');
    $tabs.responsiveTabs({
      rotate: false,
      startCollapsed: 'accordion',
      collapsible: 'accordion',
      setHash: false,
      active:1
    });

    var AllProduct = [];
    var varArray = [];
    var totalItem = 0;
    var i = 0;
    var DevicID='';
    var chkmodel=false;


    pushState = "?page="+mainTag;
    var bgImage = '//cdn.shopify.com/s/files/1/2305/6727/t/8/assets/brand-banner.png?8295392239239905881';
    $('body').on('click','#horizontalTab .pop-up-content .device-wrap a', function(e){




      var index = parseInt($(this).closest('.pop-up-content').data('index'));
      var $this = $(this);
      var $popD = $(this).closest('.pop-up-content');
      if($popD.hasClass('pop1')){
        bgImage = $this.attr('data-bgicon');
      }else{
        bgImage = '//cdn.shopify.com/s/files/1/2305/6727/t/8/assets/brand-banner.png?8295392239239905881';
      }

      $('#tab-2').attr('style','background-image: url("'+bgImage+'");');
      $('#tab-3').attr('style','background-image: url("'+bgImage+'");');






      i = index;
      if(index == 0){
        pusharray = [];
      }
      if(index == 1){
        pusharray[index+1]='';
        pusharray.splice(index+1,1);
      }
      if($.trim($(this).data('id'))){
        pusharray[index] = $.trim($(this).data('id'));
      }
      var url = '';
      for(var i in pusharray){
        url += '/'+pusharray[i]
      }

      if($popD.hasClass('pop3')==false){
        window.history.pushState('test', 'Title', pushState+url);
      }

      var mainId = $this.data('id');
      var next = $popD.data('next');



      var $device = $this.text().toLowerCase();

      $tabs.responsiveTabs('activate', index+1);
      $popD.hide();

//       for display next to next


      if($popD.hasClass('pop4')){
        var mainvariantI = mainId;

        $('.pop6 .go-backs').attr('data-prevName',mainvariantI);
      }else{

        $('.'+next+' .go-backs').attr('data-prevName',mainId);
      }

      $('#horizontalTab').attr('data-repairType',mainTag);
      $('.'+next+' .popDevice.'+next+'-'+mainId).show();
      $('.'+next+' .popDevice.'+next+'-'+mainId).siblings('.popDevice').hide();
      //replace h5 tag for heading
      var h5Tag = $this.find('.repair-texts.text-center span').text();
      $('.'+next+' .repair-texts.text-center span').text(mainId+' '+mainTag);

      var prev = parseInt($('.'+next+' .popDevice.'+next+'-'+mainId+' .go-backs').attr('data-previd'));
      var nextNext = $('.'+next).attr('data-next');
      var nxtNxt = ($('.'+nextNext+' .go-backs').attr('data-previd'));

      //Added 07-01-2019 - for redirect dell tablets
      if($popD.hasClass('pop2')){
        if($('.'+next+' .popDevice.'+next+'-'+mainId+' .button-wrap').length == 0){
        //  window.location.href="/collections/"+ $this.attr('data-id');
          $('.'+next+' .popDevice').hide();
        }
      }

      //Added 07-01-2019 - if one item redirect to next popup
      if($('.'+next+' .popDevice.'+next+'-'+mainId+' .button-wrap').length == 1){
        $('.'+next+' .popDevice.'+next+'-'+mainId+' .button-wrap a').trigger('click');
        prev = parseInt(nxtNxt) - 1;
        if(prev>=0){
          $('.'+nextNext+' .go-backs').attr('data-previd',prev);
        }
      }else{
        var prev = parseInt($('.'+nextNext).attr('data-index'))-1;
        if(prev>=0){
          $('.'+nextNext+' .go-backs').attr('data-previd',prev);
        }
      }


      var checkLinkM = $(this).attr('data-check-direct');
      if(checkLinkM == 'directLink'){
        $tabs.responsiveTabs('activate', $('.'+nextNext).attr('data-index'));
        var prev = parseInt($('.'+nextNext).attr('data-index'))-2;

        if(prev >= 0){
          $('.'+nextNext+' .go-backs').attr('data-previd',prev);
        }
        $('.'+nextNext+' .pop-up-content-inner').addClass('popwith-locating');
      }


      if(index == 1){
        DevicID = $(this).data('id');
        $('#horizontalTab').attr('data-device',DevicID);
      }

      if($(this).attr('data-link')){



        $('.'+next+' .pop-up-content-inner').addClass('popwith-locating');
        var loaderLogo = "//cdn.shopify.com/s/files/1/2305/6727/files/repairs__loader.gif?6462";
        if($('.'+next+' .pop-up-content-inner').hasClass('popwith-locating') ==  true){

          $('.pop4 .select-part-wrap .productList').html('<img alt="Loading Icon" src="'+loaderLogo+'" class="loading"><h3 class="locating-part">Locating correct part for your repair</h3>');
        }else{
			$('.pop4 .select-part-wrap .productList').html('<img alt="Loading Icon" src="'+loaderLogo+'" class="loading">');
        }
        $('.pop4 .page-sub-heading').hide();
        var $mainUrlu = $(this).attr('data-link');


        if($mainUrlu.indexOf('/products') > -1){

          window.history.pushState('test', 'Title', pushState);
          window.location.href = $mainUrlu;
        }else{

        var totalsAllProducts = 0;
        var $url = $(this).attr('data-link')+'/'+mainTag+'?view=customBanner';




        $.ajax({
          type:"GET",
          url: $url,
          success: function(data){

              if($.trim($(data).find('.customProductList').html()) != ''){
                if($(data).find('.customProductList .popDevice').length == 1){
                  var $link  = $(data).find('.customProductList .popDevice .collectionPage').attr('data-mainurlid');
                  window.location.href = $link;
                  //$('.pop4 .select-part-wrap .productList').html($(data).find('.customProductList').html());
                }else{
                  $('.'+next+' .pop-up-content-inner').removeClass('popwith-locating');
                  $('.pop4 .pop-up-content-inner').removeClass('popwith-locating');
                  $('.pop4 .page-sub-heading').show();
                  $('.pop4 .select-part-wrap .productList').html($(data).find('.customProductList').html());


                }
              }else{
                $('.'+next+' .pop-up-content-inner').removeClass('popwith-locating');
                $('.pop4 .select-part-wrap .productList').html('<div class="no-Products"><p class="noProducts">No products available</p></div>');

              }


          }

        });


           }
      }
      if($(this).hasClass('thumb-desc-wrp-new')){



        var count = 0;
        var displayItem = '';
        $('.withColor_customProductList_variant .partindi').each(function(index,e){

          if($(this).hasClass(mainId+'-indi')){
            count++;
          }
          var $this = $(this);
          if($(this).hasClass(mainId+'-indi')){
            displayItem = mainId+'-indi';
            $('.page-sub-heading').show();
            $this.show();
          }else{
            $this.hide();
          }
        });
        if(count == 1){
          $('.'+displayItem).find('.btn.collectionPage').trigger('click');
          $('#tab-6 .go-backs.aero-link').attr('data-previd',"3");
        }else{
          $('#tab-6 .go-backs.aero-link').attr('data-previd',"4");
        }


      }
      //repairsUniverse.buttonclick($(this));
      if($(this).attr('data-product')){
        var totalsAllProducts = 0;
      //  var $url = $(this).attr('data-product');
        var handleId = $(this).attr('id');

        $Produurl = $url;
        mainhandle = handleId;
        $prodHandle = handleId;

        var $url = $(this).attr('data-product');
        window.location.href = $(this).attr('data-mainurlid');


        $('.'+next+' .pop-up-content-inner').html('<img alt="Loading Icon" src="//cdn.shopify.com/s/files/1/2305/6727/files/repairs__loader.gif?6462" class="loading">');

      }
    });
    $('body').on('click','#horizontalTab .pop-up-content a#AddToCart', function(e){
      $(this).closest('.pop-up-content').hide();
      var index = parseInt($(this).closest('.pop-up-content').data('index'));
      $('#horizontalTab').responsiveTabs('activate', index+1);
    });
    $('body').on('click','#horizontalTab .pop-up-content .addOn-contents .btnAddC', function(e){
      $(this).addClass('Added');
      $(this).val('added');
      var variant = $(this).attr('data-variantid');
      var qty = 1;

      varArray.push(variant);
    });
    $('body').on('click','#horizontalTab .pop-up-content #addOnsAddTocart', function(e){
      $(this).addClass('disabled');
      var $popD = $(this).closest('.pop-up-content');
      var index = parseInt($(this).closest('.pop-up-content').data('index'));
      $popD.find('#addOnsAddTocart').text('Adding items to cart');
      var AllProduct = [];

      var qty = parseInt($('#tab-6 #Quantity').val());
      var mainId = parseInt($('#tab-6 #AddToCart').attr('data-variantid'));


      var uniqueArray = $.unique(varArray);
      for(var j in uniqueArray){
        var variant = uniqueArray[j];
        AllProduct.push({
          variant_id: variant,
          quantity_id: 1,
        });
      }



      for(var i in AllProduct){
        var tempId = AllProduct[i].variant_id;
        var tempQty= AllProduct[i].quantity_id;


        //cons
        totalsAllProducts += tempQty;

        var data_ajax = {
          "quantity": tempQty,
          "id": tempId
        }

        var params = {
          type: 'POST',
          url: '/cart/add.js',
          data: data_ajax,
          dataType: 'json',
          async:false,
          success: function(line_item) {

          },
          error: function(er) {
            var err = $.parseJSON(er.responseText);
            return false;
          }
        }
        $.ajax(params);

      }


       if(totalsAllProducts == 1){
          $('#tab-8 .acc-sub-title').text(totalsAllProducts+' item was added to your cart');
        }else{
          $('#tab-8 .acc-sub-title').text(totalsAllProducts+' items were added to your cart');
        }

      setTimeout(function(){
        $popD.find('#addOnsAddTocart').text('Added items to cart');
      },1500);
      setTimeout(function(e){
        $popD.find('#addOnsAddTocart').text('add items to cart');
        $('#tab-7').hide();
        $('#tab-8').show();

        $popD.hide();
        $tabs.responsiveTabs('activate', index+1);
        $('.pop-up-content .tips-recom-section .content h3 ').responsiveEqualHeightGrid();

        $('.withoutTab').addClass('hide');
          $('#horizontalTab_cust').removeClass('hide');
          repairsUniverse.custoHorizontalCustomizer();
        $(this).removeClass('disabled');
      },3000);

      jQuery.getJSON('/cart.js', function (cart, textStatus) {
        $('body').find('#CartCount').html(cart.item_count);
        if($(window).width() <= 1024){
          $('.mean-bar #CartCount').html(cart.item_count);
        }
        else{
          $("#CartCount").html(cart.item_count);
        }
      });
      varArray=[];

    });


  },

  // Get querystring value
  getUrlVars: function(){
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
      hash = hashes[i].split('=');
      vars.push(hash[0]);
      vars[hash[0]] = hash[1];
    }
    return vars;
  },
  // Collection page
  // Load more for collection page
  loadMore: function(){
    //alert(url);

    if($(window).width() > 767){
      $(".product-left-sidebar").stick_in_parent();
    //  $(".product-left-sidebar").css('padding-top','84px');

      $(window).scroll(function(e){
        if($(window).scrollTop() > 220){
			$(".product-left-sidebar").addClass('scroll-active');
          	$('#horizontalTab-collection ul').addClass('scroll-active');
            $('.r-tabs-nav').addClass('scroll-ul');

        }else{
          $(".product-left-sidebar").removeClass('scroll-active');
          $('#horizontalTab-collection ul').removeClass('scroll-active');
          $('.r-tabs-nav').removeClass('scroll-ul');
        }
      });
    }


    var rType = repairsUniverse.getUrlVars()["RepairType"];



    $('#horizontalTab-collection ul li').each(function(index,element){
      var i = index + 1;
      var $href = $('a',this).attr('href').replace('#','');


      if($href == rType){
        $('a',this).trigger('click');
      }
    });


    $('a#viewMore').click(function(e){
      $('.viewmore #loading').show();
      $(this).hide();
      e.preventDefault();
      var newurl = $(this).attr('data-href');

      $.ajax({
        url: newurl,
        type:"GET",
        async: "true",
        success: function(data){

          $('#all .single-device-tab').append($(data).find('#all .single-device-tab').html());
          $('#screens .single-device-tab').append($(data).find('#screens .single-device-tab').html());
          $('#batteries .single-device-tab').append($(data).find('#batteries .single-device-tab').html());
          $('#small-parts .single-device-tab').append($(data).find('#small-parts .single-device-tab').html());
          $('#accessories .single-device-tab').append($(data).find('#accessories .single-device-tab').html());
          $('.pagination').html($(data).find('.pagination').html());
          $('.viewmore').html($(data).find('.viewmore').html());
          repairsUniverse.addtocartPopup();
          repairsUniverse.collectionAfterAdd();
          repairsUniverse.grid();
          repairsUniverse.viewMoredetail();
          $('.viewmore #loading').hide();
          $('a#viewMore').show();
          if($(data).find('.next').length > 0){
            repairsUniverse.loadMore();
          }else{
            $('.viewmore').hide();
            return true;
          }
        }
      });
    });



  },
  //collection page
  // When click on View Detail
  viewMoredetail: function(){
    $('a.viewOptions').click(function(e){
      var $this = $(this);
      var newurl = $this.attr('data-url');
      if(newurl != ''){
       $.ajax({
        url: newurl,
        type:"GET",
        async: "true",
        success: function(data){


        }
       });
      }

    });
  },

  repairGuides: function(){
    $('#main_content .device_content').each(function(index, element) {
      $('.single-guide-vdo .image-wrap',this).each(function(index, element) {
        var $this = $(this);
        if($('iframe',this).length > 0){
          $this.addClass('videoWrap');
          var src = $('iframe',this).attr('src');
          if(src != ''){
            var img = src.split('/embed/')[1];
            img = img.split('?')[0];

            $this.html('<img alt="Youtube Image" class="popup-youtube-player" src="http://img.youtube.com/vi/'+img+'/0.jpg">');
            $this.append('<div class="play-icon"><img alt="Play Icon" src="//www.repairsuniverse.com/cdn/shop/t/39/assets/play-icon.png?v=143093058356202882891786660164"></div>');
            //$('img.mainVideoSmall').attr('src','http://img.youtube.com/vi/'+img+'/0.jpg');
          }
        }
      });
    });

  },

  removeItemsFromCart: function(){
      if($('#cartform .cart-item').length > 0){
        $('#cartform .cart-item').each(function(index,element){
          var $this = $(this);
          $('a.cart__remove',this).click(function(e){
            e.preventDefault();
            var id = $(this).data('id');
            $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              data: 'quantity=' + 0 + '&id=' + id ,
              dataType: 'json',
              async:false,
              beforeSend:  function(){
                $('.loading').show();
              },
              success: function(response) {
                $.ajax({
                  url:'/cart',
                  type:"GET",
                  dataType:"html",
                  async:false,
                  success:function(data){

                    var cartData = $(data).find(".cartContentAll").html();
                    $(".cartContentAll").html(cartData);
                    var cartCount = $(data).find('#CartCount').html();
                    $('body').find('#CartCount').html(cartCount);


                    repairsUniverse.removeItemsFromCart();
                    repairsUniverse.qty();
                    repairsUniverse.qtyUpdateCart();
                  }
                });
              },
              error: function() {

              }
            });
          });

        });
      }
    },

  qtyUpdateCart: function(){
        if($('#cartform .cart-item').length > 0){
          $("#update").click(function(e){
            e.preventDefault();
            var post_url = $('#cartform').attr('action');
            var form_data = $('#cartform').serialize();
            $.ajax({
              url : post_url,
              type: 'POST',
              data : form_data,
              success: function(data){
                $.ajax({
                  url:'/cart',
                  type:"GET",
                  dataType:"html",
                  async:false,
                  success:function(data){
                    var cartData = $(data).find(".cartContentAll").html();
                    $(".cartContentAll").html(cartData);
                    var cartCount = $(data).find('#CartCount').html();
                    $('body').find('#CartCount').html(cartCount);


                    repairsUniverse.removeItemsFromCart();
                    repairsUniverse.qty();
                    repairsUniverse.qtyUpdateCart();
                  }
                });
              }
            }).done(function(response){
            });
          });

        }
      },

  goToByScroll: function(id){
      id = id.replace("link", "");
      $(id).addClass('active');
      $(id).siblings('.faqs').removeClass('active');
      $('html,body').animate({
        scrollTop: $(id).offset().top - 150},'slow');
    },

  faqPage: function(){
    if($('.page-content .sidebarFAQ').length > 0){
      $('.page-content .sidebarFAQ a').click(function(e){
        var $href = $(this).attr('href');
        repairsUniverse.goToByScroll($href);
      });
      $('#which-screen-do-i-need li a').click(function(e){
		var $href = $(this).attr('href');
        repairsUniverse.goToByScroll($href);
      });
    }

  },

  collectionFilter: function(){
    if($(".toggle").length){
      $(".toggle").click(function (e) {
        e.preventDefault();
        var $this = $(this);



        $(this).toggleClass('open');
		$(this).closest('li').siblings('li').find('a').removeClass('open');
        if($(this).hasClass('open')){
          $this.next().removeClass("open");
          $this.next().find('a').removeClass('open');
        }

        if ($this.next().hasClass("show1")) {
          $this.next().removeClass("show1");
          $this.next().slideUp(350);
        } else {
          $this
          .parent()
          .parent()
          .find("li .inner")
          .removeClass("show1");
          $this
          .parent()
          .parent()
          .find("li .inner")
          .slideUp(350);
          $this.next().toggleClass("show1");
          $this.next().slideToggle(350);
        }
      });

      var pathname = window.location.pathname;
      $('.collection-page ul.accordion li').each(function(index,e){
        var $this = $(this);
        if($('a',this).attr('href') == pathname){
          $(this).addClass('selected');
          $(this).closest('ul.inner').addClass('show1').show();
          $(this).closest('ul.inner').prev('a.toggle').addClass('open');
          $(this).closest('ul.innerSub').addClass('show1').show();
          $(this).closest('ul.innerSub').prev('a.toggle').addClass('open');
        }
      });


    }
    if($('.collection-page #horizontalTab-collection').length){
      var $tabs = $('.collection-page #horizontalTab-collection');
      $tabs.responsiveTabs({
        active:0,
        rotate: false,
        startCollapsed: 'accordion',
        collapsible: 'accordion',
        setHash: false,
        click: function(e, tab) {
          setTimeout(function(){
            $('.device-content .productName').responsiveEqualHeightGrid();
          },100);
        },
        activate: function(e, tab) {

        }
      });
      if($(window).width() < 767){
        $('#horizontalTab-collection ul li a:first').trigger('click');
        if($(".popup-box .pop-up-prod-wrap").length){
          $(".popup-box .pop-up-prod-wrap").slick({
            dots: false,
            arrows: true,
            autoplay: true,
            slidesToShow: 1,
            slidesToScroll: 1
          });
        }
      }
    }

  },

  qty: function(){
    $(".inc").on('click', function() {
          var getval = $(this).prev().val();
          getval++;
          $(this).prev().val(getval);
          $("#update").trigger('click');

        });
        $(".dec").on('click', function() {
          var getval = $(this).next().val();
          if(getval > 1){
            getval--;
            $(this).next().val(getval);
            $("#update").trigger('click');
          }
        });
  },

  grid: function(){
      $('.single-device-tab .device-content .productName').responsiveEqualHeightGrid();

    if($(window).width() > 767){
      $('.product-section-slider .product-name').responsiveEqualHeightGrid();

    }
  },



  collectionAfterAdd: function(){
      $('body').on('click','.quickLink',function(e){


          $('.loading').show();
          $('.wholeProduct').hide();
          var quickLink= $(this).data('url');
          $('.productCollectionPopup').fadeIn();
          var Qty = 1;
          var varintId = $(this).data('variant');

          var data_ajax = {
            "quantity": Qty,
            "id": varintId
          }
          var params = {
            type: 'POST',
            url: '/cart/add.js',
            data: data_ajax,
            dataType: 'json',
            async:false,
            success: function(line_item) {

            },
            error: function(er) {
              var err = $.parseJSON(er.responseText);
              return false;
            }
          }
          $.ajax(params);
          jQuery.getJSON('/cart.js', function (cart, textStatus) {
            $('body').find('#CartCount').html(cart.item_count);
            if($(window).width() <= 1024){
              $('.mean-bar #CartCount').html(cart.item_count);
            }
            else{
              $("#CartCount").html(cart.item_count);
            }
          });


          $.ajax({
            type: "get",
            url: quickLink,
            dataType: "html",
            beforeSend:  function(){

            },
            success: function(data) {
              $('.productCollectionPopup').html(data);
              repairsUniverse.afterAjax();
              $('.loading').hide();
              $('.wholeProduct').show();

              if($(window).width() < 767){
                if($(".popup-box .pop-up-prod-wrap").length > 0){
                  $(".popup-box .pop-up-prod-wrap").slick({
                    dots: false,
                    arrows: true,
                    autoplay: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  });
                }
              }
              else{
                $('.product-section .pop-up-prod-wrap .product-name').responsiveEqualHeightGrid();
              }

            },
            error: function() {

            }
          });
        });
      //});
  },

  afterAjax: function(){
    $('.productCollectionPopup .close').click(function(e){
       $('.productCollectionPopup').fadeOut();
    });
    jQuery.getJSON('/cart.js', function (cart, textStatus) {
		$('body').find('#CartCount').html(cart.item_count);
      if($(window).width() <= 1024){
          $('.mean-bar #CartCount').html(cart.item_count);
        }
      else{
        $("#CartCount").html(cart.item_count);
      }
    });

    $('.afterAddBtnAddCart#AddToCart').click(function(e){
      var $this = $(this);
      var productId = $(this).data('id');
      var qty = 1;
      var data_ajax = {
        "quantity": qty,
        "id": productId
      }
      var params = {
          type: 'POST',
          url: '/cart/add.js',
          data: data_ajax,
          dataType: 'json',
          async:false,
          success: function(line_item) {

            $this.hide();
            $this.next('div.itemAdded').show();
          },
          error: function(er) {
            var err = $.parseJSON(er.responseText);
            return false;
          }
        }
        $.ajax(params);



        jQuery.getJSON('/cart.js', function (cart, textStatus) {

          var freeship = parseInt('40');
                                  var free2dayship = parseInt('1000');
                                  var mprice =  parseFloat(Shopify.formatMoney(cart.total_price,window.money_format).replace('$','').replace(',',''));

          if(mprice < freeship){
            var remaining = parseFloat(freeship) - parseFloat(mprice);
            $('.continue-shopping .freeShippingText').text('FREE SHIPPING? Add $'+remaining.toFixed(2)+' more.');
          }else if(mprice < free2dayship){
            var remaining = parseFloat(free2dayship) - parseFloat(mprice);
            $('.continue-shopping .freeShippingText').text('Product ships free! For Free 2 Day  Shipping Add $'+remaining.toFixed(2)+'.');
          }else if(mprice > free2dayship){
            $('.continue-shopping .freeShippingText').text('You earned Free 2 Day Shipping.');
          }

          /*var freeship = parseInt('40');
          var mprice =  parseFloat(Shopify.formatMoney(cart.total_price,window.money_format).replace('$','').replace(',',''));

          if(mprice < freeship){
            var remaining = parseFloat(freeship) - parseFloat(mprice);
            remaining = remaining.toFixed(2);

            $('.continue-shopping .freeShippingText').text('Add $'+remaining+' more for FREE SHIPPING!');
          }
          else if(mprice > freeship){
            $('.continue-shopping .freeShippingText').text('Free shipping');
          }
          else{
            $('.continue-shopping .freeShippingText').text('Free shipping');
          } */



          $('body').find('#CartCount').html(cart.item_count);
          if($(window).width() <= 1024){
            $('.mean-bar #CartCount').html(cart.item_count);
          }
          else{
           $("#CartCount").html(cart.item_count);
          }
        });
    });


    $('.removeProduct').click(function(e){
      var productId = $(this).data('productid');
      var qty = 0;
      jQuery.getJSON('/cart.js', function (cart, textStatus) {
        for(var i=0; i < cart.items.length; i++){
          if(cart.items[i].id == productId){
             qty = parseInt(cart.items[i].quantity) - 1;
             jQuery.post('/cart/update.js', 'updates['+productId+']='+qty);
          }
        }
      });
      setTimeout(function(){
        jQuery.getJSON('/cart.js', function (cart, textStatus) {
          $('body').find('#CartCount').html(cart.item_count);
          if($(window).width() <= 1024){
            $('.mean-bar #CartCount').html(cart.item_count);
          }
          else{
           $("#CartCount").html(cart.item_count);
          }
          $('.productCollectionPopup').fadeOut();
        });
      },3000);
    });
  },

  footerToggle: function () {

      $(".footer-links h5").click(function (e) {
        if ($(window).width() < 768) {
          $(this).children('i').toggleClass('fa-plus fa-minus');
          $(this).siblings('ul').slideToggle();
        }
        else {
        }
      });
      $(".footer-links .sub-title ").click(function (e) {
        if ($(window).width() < 768) {
          $(this).children('i').toggleClass('fa-plus fa-minus');
          $(this).siblings('.footer-news-wrap').slideToggle();
        }
        else {

        }
      });
    },
    // collection add to cart pop up
  addtocartPopup: function () {
        $('.prouduct .add-to-cart').click(function () {
            $('.collection-popup').fadeIn();
            $('.heapBox').fadeIn();
            $('.prod-slider').slick('refresh');
            $('.prod-tab').slick('refresh');
        });
    },

    //readmore jquery

  readmore: function () {
        $('.read-more-link').click(function () {
            $('.read-more-content').toggleClass('full-height');
        });

    },

    //popup toggle jquery
  closePopup: function () {
        $('.popup-overlay').click(function () {
            $(this).parents('.popup').fadeOut();
          $('body').removeClass('productPopupActive');

        });

        $('.popup .close').click(function () {

          //for popup containg iframe
          if($('.popup iframe').length > 0){
            var a = $('.popup iframe').attr('src');
            $('.popup iframe').attr('src','');
            $('.popup iframe').attr('src',a);
          }


          $(this).parents('.popup').fadeOut();
          $('body').removeClass('productPopupActive');
          if($('.upsellProduct .product-wrap').length > 0){
            $('.upsellProduct .product-wrap').each(function(index,e){
				$('#AddToCart',this).show();
              	$('.itemAdded',this).hide();
            });
          }

        });
    },

    // mean menu jQuery
  meanMenu: function () {
        jQuery('header nav').meanmenu();
    },

    //home page banner slider start
  bxSider: function () {
        $('.bxslider').bxSlider({
            mode: 'fade',
            captions: true,
            auto: false
        });
    },
    //home page banner slider end

    //common dropdown start
  dropdown: function () {

        $('select.custom-select').each(function () {

            var $this = $(this), numberOfOptions = $(this).children('option').length;

            $this.addClass('select-hidden');
            $this.wrap('<div class="select"></div>');
            $this.after('<div class="select-styled"></div>');

            var $styledSelect = $this.next('div.select-styled');
            $styledSelect.text($this.children('option').eq(0).text());

            var $list = $('<ul />', {
                'class': 'select-options'
            }).insertAfter($styledSelect);

            for (var i = 0; i < numberOfOptions; i++) {
                $('<li />', {
                    text: $this.children('option').eq(i).text(),
                    rel: $this.children('option').eq(i).val()
                }).appendTo($list);
            }

            var $listItems = $list.children('li');

            $styledSelect.click(function (e) {
                e.stopPropagation();
                $('div.select-styled.active').not(this).each(function () {
                    $(this).removeClass('active').next('ul.select-options').slideUp();
                });
                $(this).toggleClass('active').next('ul.select-options').toggle();
            });

            $listItems.click(function (e) {
                e.stopPropagation();
                $styledSelect.text($(this).text()).removeClass('active');
                $this.val($(this).attr('rel'));
                $list.hide();

            });

            $(document).click(function () {
                $styledSelect.removeClass('active');
                $list.hide();
            });

        });
    },
    //common dropdown end

  heapBox: function () {
        $(".basic-example").heapbox({
            'effect': {
                'type': 'fade',
                'speed': 100
            },
            'openStart': function () {

            },
            'closeComplete': function () {  },
        });
    },

  slickCall: function () {


      if($('.slider-for').length > 0){
        $('.slider-for').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          asNavFor: '.slider-nav'
        });
        //if($(window).width() > 767){
          $('.slider-for').on('beforeChange', function(event, slick, currentSlide, nextSlide){
            $(slick.$slides.get(nextSlide)).find('img').elevateZoom({
              zoomType: "inner",
              cursor: "crosshair",
               zoomWindowFadeIn: 500,
               zoomWindowFadeOut: 750,

            });
          });
      // }
      }
      if($('.slider-nav').length > 0){
        $('.slider-nav').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          asNavFor: '.slider-for',
          dots: false,
          centerMode: false,
          vertical: true,
          Infinite:false,
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            }
          ]
        });
      }


        if ($(window).width() < 767) {

          if($(".diy-repairs-slider").length > 0){
            $(".diy-repairs-slider").slick({
                dots: false,
                arrows: true,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,

            });
          }
          if($(".repair-sec-slider").length > 0){
            $(".repair-sec-slider").slick({
                dots: false,
                arrows: true,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
            });
          }
          if($(".help-steps-slider").length > 0){
            $(".help-steps-slider").slick({
                dots: false,
                arrows: true,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
            });
          }


            if($(".popup-box .pop-up-prod-wrap").length > 0){
              $(".popup-box .pop-up-prod-wrap").slick({
                dots: false,
                arrows: true,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
              });
            }



        }
        else {

        }
    },

    toolTip: function () {
        $(".tooltiptext").asTooltip({
            show: {
                target: '.tooltiptext'
            },
            hide: {
                target: '.tooltiptext'
            }
        });
        $(".tooltiphtml").asTooltip({
            show: { event: 'click' },
            hide: { event: 'click' },
            content: '<a href="#">helllo</a>',
        });
    },

    gridjs: function(){

      $('.collection-page .productName').responsiveEqualHeightGrid();

      jQuery(function($) {
        $('.qua-name').responsiveEqualHeightGrid();
        $('.quality-inner img').responsiveEqualHeightGrid();
        $('.quality-inner p').responsiveEqualHeightGrid();
        $('.thumb-desc-wrp').responsiveEqualHeightGrid();
        $('.desc h5').responsiveEqualHeightGrid();
        $('.desc p').responsiveEqualHeightGrid();
        $('.product-selection-tab .quality .thumb-desc-wrp h6').responsiveEqualHeightGrid();

       // $('.pop-up-content-inner .device-wrap .button-wrap').responsiveEqualHeightGrid();
        $('.pop-up-content .tips-recom-section .content h3 ').responsiveEqualHeightGrid();

      });
    },
}





$(document).ready(function () {

    var winWidth = $(window).width();
    var winHeight = $(window).outerHeight();
    var winScroll;

    repairsUniverse.init();

});

$(window).load(function () {
    $('.loader-wrapper').fadeOut();
});

// Hide Header on scroll down
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var headerHeight = $('.while-scroll-header').outerHeight();

$(window).scroll(function (e) {
    winScroll = $(window).scrollTop();
    didScroll = true;

    afterScrollHeader();
});

function afterScrollHeader() {
    if (winScroll > 250) {
        $('.after-scroll-header').addClass('in-view');
    }
    else {
        $('.after-scroll-header').removeClass('in-view');
    }
}

setInterval(function () {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    }
}, 250);

function hasScrolled() {
    var st = $(this).scrollTop();
    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta)
        return;

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > headerHeight) {
        // Scroll Down
        $('.while-scroll-header').removeClass('nav-down').addClass('nav-up');
    } else {
        // Scroll Up
        if (st + $(window).height() < $(document).height()) {
            $('.while-scroll-header').removeClass('nav-up').addClass('nav-down');
        }
    }
    lastScrollTop = st;
}

$(document).ready(function () {
    $(".header-right-links .cart").click(function (e) {
        $(".cart-drop").slideToggle();
    });
    $('.cart-drop').click(function (e) {
        e.stopPropagation();
    });

    $(".header-right-links  li").click(function (e) {
        $(".top-search-bar").addClass("open");
    });
    $(".top-search-bar  .close").click(function (e) {
        $(".top-search-bar").removeClass("open");
    });

  //====================================Scroll to Top Button =================================================//
    $(window).scroll(function () {
        var windowpos = $(window).scrollTop();
        if (windowpos >= 36) {
            $('#fsb_container').addClass('hide_hello');
            $('#header').addClass('sticky_nav');
        } else {
            $('#fsb_container').removeClass('hide_hello');
            $('#header').removeClass('sticky_nav');
        }
    });

  $(".menu-tabs").tabs({
      event: "mouseover"
  });

  $('body').on('click', '.go-back', function () {
    var goAnchor = $(this).attr('data-anchorid');
    $('#' + goAnchor).fadeOut();

    //setTimeout(function () {
      $('.PopupBox').removeClass('open');
    //},700)
  });
});

$(document).on('click', 'a[href^="#"]', function (event) {
  event.preventDefault();

});

$(document).ready(function () {

  setTimeout(function(){
    var review = '';
    $('#tempTestimonials #reviewsList .review-list').each(function(index,element){
      var name = $('.review-author',this).text();
      var date = $('.review-date',this).text();
      var reviewBody = $('.review-body',this).html() +'<br>'+ $('.review-product-link',this).html();
      review += '<div class="single-testi">';
      review += '<p>'+reviewBody+'</p>';
      review += '<div class="client-name h4">'+name+'</div>';
      review += '<div class="place h5">'+date+'</div>';
      review += '</div>';
    });



    $('.testi-carousal').html(review);
    $('.testi-carousal').hide();
    setTimeout(function(){
      $('.testi-carousal').show();
      $('.testi-carousal').owlCarousel({
        autoplay: true,
        loop: true,
        nav: true,
        items: 1,
        stagePadding: 500,
        margin: 150,
        responsive: {
          0: {
            stagePadding: 0,
            margin: 15
          },
          767: {
            stagePadding: 100,
            margin:50
          },
          1199: {
            stagePadding: 250,
            margin: 100
          },
          1399: {
            stagePadding: 350,
            margin: 150
          },
          1680: {

          }
        }
      });
    },1000);
  },5000);







});
